import { Link } from 'react-router-dom';
import AnimatedStat from '@/components/base/AnimatedStat';
import { useTranslation } from 'react-i18next';

export default function OverviewSection() {
  const { t } = useTranslation();
  return (
    <section className="py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/10260502-bb37-441d-8546-90487bad8ae7_compressed_ChatGPT-Image-5-aot-2026-18_30_41.webp"
                alt="Équipe IS TELECOM sur site de télécommunication"
                className="w-full h-[500px] lg:h-[600px] object-cover parallax-slow"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary-500 rounded-3xl -z-10 hidden lg:block animate-float"></div>
          </div>
          <div>
            <div className="inline-flex items-center border border-primary-300/60 rounded-full px-4 py-1.5 mb-6">
              <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">
                {t('overview.badge')}
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-foreground-950 mb-6 leading-tight">
              {t('overview.titleLine1')}<br />{t('overview.titleLine2')}
            </h2>
            <p className="text-foreground-600 text-lg leading-relaxed mb-8">
              {t('overview.description')}
            </p>
            <Link
              to="/a-propos"
              className="inline-flex items-center gap-2 bg-background-950 text-white hover:bg-background-800 px-6 py-3 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap mb-12"
            >
              {t('overview.learnMore')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-background-200/70">
              <AnimatedStat value={18} suffix="+" label={t('overview.statYears')} />
              <AnimatedStat value={50} suffix="+" label={t('overview.statCountries')} />
              <AnimatedStat value={2000} suffix="+" label={t('overview.statProjects')} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}